import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { SagepayPiSavedCardComponentDef } from '@df/module-sagepay';
import { ValidateDataErrorDirective } from '@df/ui/form/validate-data-error.directive';
import { CheckoutFormComponent } from '../../../checkout/checkout-form.component';
import { CheckoutStepComponent } from '../../../checkout/checkout-step.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../../ui/form/mui-input.directive';
import { SagepayPiServiceDecorator } from './sagepay.service.decorator';

@Component({
    selector: 'sagepay-pi-saved-card',
    templateUrl: './sagepay-pi-saved-card.html',
    standalone: true,
    imports: [FormsModule, InputWrapBodyDirective, InputWrapComponent, MuiInputDirective, ValidateDataErrorDirective],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: NgForm
        }
    ]
})
export class SagepayPiSavedCardComponent extends SagepayPiSavedCardComponentDef implements OnInit, OnDestroy {
    protected sagepayPiServiceDecorator = inject(SagepayPiServiceDecorator);

    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        changeDetectorRef: ChangeDetectorRef,
        scrollToService: ScrollToService,
        checkoutStepComponent: CheckoutStepComponent
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions.add(
            this.sagepayPiServiceDecorator.dataUpdate.subscribe(() => {
                this.onDataUpdate();
            })
        );

        this.onDataUpdate();
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();

        if (this.cardCode) {
            this.sagepayPiServiceDecorator.setCode(this.cardCode, '');
        }
    }

    get cvc(): string {
        return this.data.cvc;
    }

    set cvc(value: string) {
        this.data.cvc = value;

        if (this.cardCode) {
            this.sagepayPiServiceDecorator.setCode(this.cardCode, value);
        }
    }

    get cardCode(): string | undefined {
        return this.card?.code;
    }

    protected onDataUpdate(): void {
        const cardCode = this.cardCode;

        if (cardCode) {
            this.data.cvc = this.sagepayPiServiceDecorator.getCode(cardCode) || '';
        }
    }
}
